import { render, staticRenderFns } from "./LockerManagerSidebar.vue?vue&type=template&id=b41b61b0&"
import script from "./LockerManagerSidebar.vue?vue&type=script&lang=js&"
export * from "./LockerManagerSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports